import React from 'react';

import AssetManager from '@components/workbench/individual/asset_manager/main';
import Palette from '@components/workbench/individual/palette/palette';

class PaletteTool extends React.Component {
  render() {
    return (
      <AssetManager extractColors>
        <Palette />
      </AssetManager>
    );
  }
}

export default PaletteTool;
